import { Pipe, PipeTransform } from '@angular/core'
import { DeviceTypeEnum } from '@wm-front/admin/graphql'

@Pipe({
  name: 'deviceIcon',
  standalone: true,
})
export class DeviceIconPipe implements PipeTransform {
  /** Transform device type into icon name string
   * @param { DeviceTypeEnum }
   * @returns { string }
   */
  public transform(value: DeviceTypeEnum, size = 'xs'): string {
    switch (value) {
      case DeviceTypeEnum.Elevator:
        return `elevator-${size}`
      case DeviceTypeEnum.Escalator:
        return `escalator-${size}`
      case DeviceTypeEnum.FireAlarm:
        return `fire-${size}`
      case DeviceTypeEnum.Door:
        return `doors-${size}`
      case DeviceTypeEnum.Hvac:
        return `hvac-${size}`
      default:
        return `elevator-${size}`
    }
  }
}
